const headerSearchIcon = document.querySelector('.header__content-icons-container--search');

if (headerSearchIcon) {
    const debounce = function (func, wait, immediate) {
        let timeout;
        return function () {
            const context = this,
                args = arguments;
            const later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            const callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };

    const menuHeader = document.querySelector('.main-nav');
    const searchHeader = document.querySelector('.header__content--search');
    const searchForm = document.querySelector('.header__search-form');
    const searchBar = document.querySelector('.header__search-bar');
    const closeSearch = document.querySelector('.header__search-close');
    const searchContainer = document.querySelector('.search__container');
    const searchContent = document.querySelector('.search__content');
    const searchPages = document.querySelector('.search__pages-list');
    const searchResultsCount = document.querySelector('.search__pages-count');
    const searchNoResults = document.querySelector('.search__no-results');
    const bodyEl = document.body;
    const headerInputWrapper = document.querySelector('.header__search-wrapper');
    const searchResultText = document.querySelector('.search__pages-heading');
    const searchResultsShowBtn = document.querySelector('.search__show-all-results');
    const searchResultsShowCount = document.querySelector('.search__show-all-results-count');

    let isBelow1200 = window.innerWidth < 1200;
    let isSearchOpen = false;

    function handleResize() {
        const newIsBelow1200 = window.innerWidth < 1200;

        if (newIsBelow1200 !== isBelow1200) {
            isBelow1200 = newIsBelow1200;

            if (isBelow1200 && isSearchOpen) {
                bodyEl.classList.remove('-search-open');
                searchContainer.style.opacity = 0;
                searchBar.value = '';
            }
        }
    }
    window.addEventListener('resize', handleResize);

    searchForm.addEventListener('submit', (event) => {
        event.preventDefault();
    });

    headerSearchIcon.addEventListener('click', (event) => {
        event.preventDefault();
        menuHeader.classList.add('main-nav--hidden');
        headerSearchIcon.classList.add('header__content-icons-container--hidden');
        searchHeader.classList.remove('header__content--hidden');
        searchBar.focus();
    });

    searchBar.addEventListener(
        'keyup',
        debounce(() => {
            const url = searchForm.getAttribute('data-ajax-action') + `?query=${searchBar.value}`;
            const options = {
                method: 'GET',
            };
            fetch(url, options)
                .then((response) => {
                    return response.json();
                })
                .then((result) => {
                    if (searchBar.value !== result.query) {
                        return;
                    }
                    searchContainer.classList.remove('search__container--hidden');
                    setTimeout(() => {
                        searchContainer.style.opacity = 1;
                    });
                    bodyEl.classList.add('-search-open');
                    isSearchOpen = true;

                    if (window.matchMedia('(min-width: 1200px)').matches) {
                        const distanceLeft = headerInputWrapper.getBoundingClientRect().left;
                        searchContent.style.maxWidth = `${headerInputWrapper.clientWidth}px`;
                        searchContent.style.left = `${distanceLeft}px`;
                    } else {
                        searchContent.style.maxWidth = '100%';
                        searchContent.style.left = '0';
                        searchHeader.classList.remove('header__content--hidden');
                        isSearchOpen = false;
                    }

                    document.querySelector('.header').classList.remove('header--hidden');
                    renderResult(result.result);
                })
                .catch((error) => {
                    throw new Error(error);
                });
        }, 350)
    );

    closeSearch.addEventListener('click', () => {
        menuHeader.classList.remove('main-nav--hidden');
        headerSearchIcon.classList.remove('header__content-icons-container--hidden');
        searchHeader.classList.add('header__content--hidden');
        searchContainer.style.opacity = 0;
        setTimeout(() => {
            searchContainer.classList.add('search__container--hidden');
        });
        bodyEl.classList.remove('-search-open');

        if (window.matchMedia('(max-width: 1200px)').matches) {
            searchBar.value = '';
        }
    });

    searchContainer.addEventListener('click', (event) => {
        if (event.target !== searchContent) {
            menuHeader.classList.remove('main-nav--hidden');
            headerSearchIcon.classList.remove('header__content-icons-container--hidden');
            searchHeader.classList.add('header__content--hidden');
            searchContainer.style.opacity = 0;
            setTimeout(() => {
                searchContainer.classList.add('search__container--hidden');
            });
            bodyEl.classList.remove('-search-open');
        }
    });

    function renderResult(result) {
        let pages = '';
        let count = '';
        searchPages.innerHTML = pages;
        searchResultsCount.innerHTML = count;
        if (Object.values(result.pages).length > 0) {
            let countPageHtml = `
                <span>(${result.count})</span>
            `;
            count += countPageHtml;
            Object.values(result.pages)
                .slice(0, 6)
                .forEach((page) => {
                    let pageHtml = `
                    <li>
                        <a class="result-item" href='${page.url}'>
                        <div class="result-item__wrapper">
                            <img class="result-item__img" src='${page.imageUrl}' alt='${page.title}' width='100' height='70'/>
                            <div class="result-item__info">
                                <div class="result-item__title">${page.title}</div>
                                <div class="result-item__description">${page.description}</div>
                            </div>
                        </div>
                        </a>
                    </li>
                    `;
                    pages += pageHtml;
                });
            searchPages.innerHTML = pages;
            searchResultsCount.innerHTML = count;
            searchResultsShowCount.innerHTML = count;
            searchPages.style.display = 'grid';
            searchResultText.style.display = 'block';
            searchNoResults.style.display = 'none';
            searchResultsShowBtn.style.display = 'flex';
            searchResultsShowBtn.href = searchResultsShowBtn.href.split('?')[0] + `?query=${searchBar.value}`;
        } else {
            searchPages.style.display = 'none';
            searchNoResults.style.display = 'block';
            searchResultText.style.display = 'none';
            searchResultsShowBtn.style.display = 'none';
        }
    }

    window.addEventListener('resize', () => {
        if (window.matchMedia('(min-width: 1200px)').matches) {
            const distanceLeft = headerInputWrapper.getBoundingClientRect().left;
            searchContent.style.maxWidth = `${headerInputWrapper.clientWidth}px`;
            searchContent.style.left = `${distanceLeft}px`;
            searchHeader.classList.add('header__content--hidden');
            menuHeader.classList.remove('main-nav--hidden');
            headerSearchIcon.classList.remove('header__content-icons-container--hidden');
        } else {
            searchContent.style.maxWidth = '100%';
            searchContent.style.left = '0';
            searchHeader.classList.remove('header__content--hidden');
        }
    });
}
